import React from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';

export default function MessageOutgoingViewModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_MESSAGE_OUTGOING_VIEW}
      renderHeader={({ header, body }: IModalProps) => (
        <MessageOutgoingViewHeader header={header} body={body} />
      )}
      renderContent={({ header, body }: IModalProps) => (
        <React.Fragment>
          <MessageOutgoingViewBody header={header} body={body} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  body: string;
}

const MessageOutgoingViewHeader = ({ header, body }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const MessageOutgoingViewBody = ({ header, body }: IModalProps) => {
  return <pre>{body}</pre>;
};
